export const legacyAdExtensionsAssociationsContainer = (components, theme = {}) => ({
  // associations editor container
  '& .associations__container': {
    '& .panel-body[data-bind*="showEditor"] .associations': {
      '& .doubleListBox': {
        '& .layout-columns-container': {

          // Filter "column"
          '& .layout-columns-element[data-bind*="features.filtering"]': {
            display: 'flex',
            flexDirection: 'column',
            float: 'unset',
            minHeight: 'unset',
            padding: 0,
            width: 'unset',

            '& > .form-group[data-bind*="features.filtering"]': {
              order: 2,

              '& .dlb-filter-alignPlaceholder': {
                padding: 0,
                position: 'absolute',
                width: 450,

                '& .searchbox': {

                  '& input.searchbox-input.form-control': {
                    border: `1px solid ${theme.palette.neutralSecondary}`,
                    borderRadius: 0,
                    height: 48,
                    paddingTop: 5,
                    paddingLeft: 48,
                  },

                  '& .form-control-feedback': {
                    position: 'absolute',
                    top: 16,
                    left: 16,
                    right: 'unset',
                    width: 'unset',
                    height: 'unset',
                    lineHeight: '16px',
                    pointerEvents: 'auto',

                    '& .filter_search_icon_small': {
                      display: 'block',
                      fontSize: 16,
                    },
                  },
                },
              },
            },

            '& > div[data-bind*="showMaximumSelectionAlert"]': {
              order: 1,
              marginBottom: 10.5,
            },
          },

          // Available extensions column
          '& .layout-columns-element:nth-child(2)': {
            float: 'left',
            marginTop: 48,
            marginRight: 8,
            padding: 0,
            width: 450,
            overflowY: 'hidden',

            // list
            '& .row.form-group': {
              paddingBottom: 8,

              '& .col-sm-12': {
                border: `1px solid ${theme.palette.neutralSecondary}`,
                borderTop: 0,
                padding: 0,

                '& .panel-form': {
                  '& .panel-heading': {
                    padding: 0,

                    '& .panel-title': {
                      fontSize: 14,
                      height: 'auto',
                      lineHeight: '36px',
                      marginTop: 'unset',
                      overflow: 'hidden',
                      padding: [0, 8],
                      textOverflow: 'ellipsis',
                      whiteSpace: 'nowrap',
                    },
                  },

                  '& .panel-body': {
                    marginBottom: 0,
                    display: 'flex',
                    flexDirection: 'column',

                    '& .dlb-source-container': {
                      display: 'flex',
                      flexDirection: 'column',
                      flexGrow: 1,
                      maxHeight: 272,
                      minHeight: 272,

                      '& .dlb-source-list': {
                        flexGrow: 1,
                        outline: 'none',
                        overflowY: 'auto',

                        '& .dlbItem': {
                          padding: '0 8px',

                          '& .dlbItem-actions': {
                            float: 'right',
                            marginTop: 8,

                            '& .dlbItem-customAction, & .arrow-button': {
                              textDecoration: 'none',

                              '&:focus': {
                                outline: 'solid 1px',
                                outlineOffset: 2,
                              },
                            },

                            '& .arrow-button.enabled': {
                              marginLeft: 10,
                            },
                          },

                          '& .dlbItem-content': {
                            minHeight: 36,
                            lineHeight: '36px',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            whiteSpace: 'nowrap',

                            '& .type-bold': {
                              fontWeight: 600,
                            },

                            '& .wordwrap, .itemTemplate-text, .appListItem-text': {
                              overflow: 'hidden',
                              textOverflow: 'ellipsis',
                              whiteSpace: 'nowrap',
                            },

                            '& .itemTemplate-text': {
                              padding: '4px 0px 2px 0px',
                              lineHeight: '28px',

                              '& li': {
                                height: 32,
                                lineHeight: '32px',

                                '& a': {
                                  verticalAlign: 'middle',
                                },
                              },
                            },

                            '& .image-adextension-v2-item, & .image-adextension-v1-item': {
                              width: '160px',
                              float: 'left',
                              position: 'relative',
                              marginTop: '10px',
                              '& img': {
                                width: '150px',
                                height: '100px',
                              },
                              '& .overlayText': {
                                lineHeight: 'normal',
                                paddingLeft: '5px',
                                position: 'absolute',
                                bottom: 0,
                                width: '150px',
                                height: '30px',
                                fontSize: '11px',
                                color: '#FFFFFF',
                                opacity: 0.9,
                                background: '#505050',
                              },
                            },
                            '& .image-adextension-v2-text': {
                              float: 'left',
                              lineHeight: 'normal',
                              width: '175px',
                              textOverflow: 'ellipsis',
                              maxWidth: '175px',
                              paddingTop: '20px',
                            },
                            '& .image-adextension-v2-badge': {
                              float: 'left',
                              lineHeight: 'normal',
                              textOverflow: 'ellipsis',
                              fontSize: '11px',
                              marginTop: 12,
                              '& span': {
                                display: 'inline-block',
                                background: '#D9D9D9',
                                borderRadius: '8px',
                                padding: '2px 7px',
                              },
                            },
                          },
                        },

                        '& .k-loading-mask': {
                          display: 'none',
                        },
                      },
                    },
                  },
                },
              },
            },

            // pager
            '& .dlb-pager-container': {
              padding: 0,

              '& .pager': {
                height: 'auto',
                textAlign: 'unset',

                '& .pager-page': {
                  marginBottom: 8,

                  '& span': {
                    marginLeft: 6,
                    verticalAlign: 'baseline',
                  },
                },
              },
            },
          },

          // Selected extensions column
          '& .layout-columns-element:nth-child(3)': {
            float: 'left',
            marginRight: 0,
            padding: 0,
            width: 450,

            // list
            '& .row.form-group': {
              paddingBottom: 8,

              '& .col-sm-12': {
                padding: 0,
                border: `1px solid ${theme.palette.neutralSecondary}`,

                '& .panel-form': {
                  '& .panel-heading': {
                    padding: 0,

                    '& .panel-title': {
                      fontSize: 14,
                      height: 'auto',
                      lineHeight: '36px',
                      marginTop: 'unset',
                      overflow: 'hidden',
                      padding: [0, 8],
                      textOverflow: 'ellipsis',
                      whiteSpace: 'nowrap',
                    },
                  },

                  '& .panel-body': {
                    marginBottom: 0,

                    '& .dlb-selected-container': {
                      display: 'flex',
                      flexDirection: 'column',
                      minHeight: 319,
                      maxHeight: 319,

                      '& .dlb-selected-list': {
                        flexGrow: 1,
                        overflowY: 'auto',

                        '& .dlbItem': {
                          padding: [0, 8],

                          '&.k-state-selected a': {
                            color: '#006cbe', // Fixing A11Y contrast issue. Original link color was #0078d4
                          },

                          '& .arrow-button': {
                            textDecoration: 'none',

                            '&:focus': {
                              outline: 'solid 1px',
                              outlineOffset: 2,
                            },
                          },

                          '& .arrow-button.remove': {
                            marginRight: 10,
                            marginTop: 8,
                            float: 'right',
                            padding: 0,
                          },

                          '& .dlbItem-actions': {
                            float: 'right',
                            marginTop: 8,

                            '& .dlbItem-customAction': {
                              textDecoration: 'none',

                              '&:focus': {
                                outline: 'solid 1px',
                                outlineOffset: 2,
                              },
                            },
                          },

                          '& .dlbItem-content': {
                            minHeight: 36,
                            lineHeight: '36px',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            whiteSpace: 'nowrap',

                            '& .type-bold': {
                              fontWeight: 600,
                            },

                            '& .wordwrap, .itemTemplate-text, .appListItem-text': {
                              overflow: 'hidden',
                              textOverflow: 'ellipsis',
                              whiteSpace: 'nowrap',
                            },

                            '& .itemTemplate-text': {
                              '& li': {
                                height: 32,
                                lineHeight: '32px',

                                '& a': {
                                  verticalAlign: 'middle',
                                },
                              },
                            },

                            '& .image-adextension-v2-item, & .image-adextension-v1-item': {
                              width: '160px',
                              float: 'left',
                              position: 'relative',
                              marginTop: '10px',
                              '& img': {
                                width: '150px',
                                height: '100px',
                              },
                              '& .overlayText': {
                                lineHeight: 'normal',
                                paddingLeft: '5px',
                                position: 'absolute',
                                bottom: 0,
                                width: '150px',
                                height: '30px',
                                fontSize: '11px',
                                color: '#FFFFFF',
                                opacity: 0.9,
                                background: '#505050',
                              },
                            },
                            '& .image-adextension-v2-text': {
                              float: 'left',
                              lineHeight: 'normal',
                              width: '175px',
                              textOverflow: 'ellipsis',
                              maxWidth: '175px',
                              paddingTop: '20px',
                            },
                            '& .image-adextension-v2-badge': {
                              float: 'left',
                              lineHeight: 'normal',
                              textOverflow: 'ellipsis',
                              fontSize: '11px',
                              marginTop: 12,
                              '& span': {
                                display: 'inline-block',
                                background: '#D9D9D9',
                                borderRadius: '8px',
                                padding: '2px 7px',
                              },
                            },
                          },
                        },

                        '& .k-loading-mask': {
                          display: 'none',
                        },
                      },
                    },
                  },
                },
              },
            },

            // pager
            '& .dlb-pager-container': {
              padding: 0,

              '& .pager': {
                height: 'auto',
                textAlign: 'unset',

                '& .pager-page': {
                  marginBottom: 8,

                  '& span': {
                    marginLeft: 6,
                    verticalAlign: 'baseline',
                  },
                },
              },
            },
          },
        },
      },
    },

    // Save bar
    '& .panel-body .save-bar': {
      paddingTop: 10,
      borderTop: `1px solid ${theme.palette.neutralLight}`,
    },
  },
});
